export default {
  fi: {
    HomeScene: {
      title: 'Luo vikailmoitus',
      successTitle: 'Vikailmoitus vastaanotettu.',
      successClose: 'Sulje',
      noVisibleVehicles:
        'Et voi luoda vikailmoitusta, koska käyttäjätunnuksesi ryhmissä ei ole yhtään ajoneuvoa. Ota yhteyttä yrityksesi pääkäyttäjään.',
    },
  },
};
